import React from "react";
import { Box, Typography } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";

function ScatteredDots() {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        borderRadius: 4,
        overflow: "hidden",
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 700 160"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Top-left cluster */}
        <line
          x1="18"
          y1="28"
          x2="58"
          y2="28"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="3 5"
          strokeLinecap="round"
          opacity="0.5"
        />
        <line
          x1="24"
          y1="38"
          x2="52"
          y2="38"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="2 6"
          strokeLinecap="round"
          opacity="0.35"
        />
        <line
          x1="12"
          y1="48"
          x2="38"
          y2="48"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="3 4"
          strokeLinecap="round"
          opacity="0.25"
        />

        {/* Top-right cluster */}
        <line
          x1="642"
          y1="22"
          x2="688"
          y2="22"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="3 6"
          strokeLinecap="round"
          opacity="0.35"
        />
        <line
          x1="650"
          y1="34"
          x2="682"
          y2="34"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="2 5"
          strokeLinecap="round"
          opacity="0.5"
        />
        <line
          x1="658"
          y1="44"
          x2="690"
          y2="44"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="4 5"
          strokeLinecap="round"
          opacity="0.25"
        />

        {/* Bottom-left cluster */}
        <line
          x1="22"
          y1="112"
          x2="60"
          y2="112"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="2 5"
          strokeLinecap="round"
          opacity="0.25"
        />
        <line
          x1="14"
          y1="122"
          x2="48"
          y2="122"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="3 6"
          strokeLinecap="round"
          opacity="0.5"
        />
        <line
          x1="28"
          y1="132"
          x2="56"
          y2="132"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="2 4"
          strokeLinecap="round"
          opacity="0.35"
        />

        {/* Bottom-right cluster */}
        <line
          x1="644"
          y1="114"
          x2="686"
          y2="114"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="3 5"
          strokeLinecap="round"
          opacity="0.5"
        />
        <line
          x1="652"
          y1="126"
          x2="680"
          y2="126"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="2 6"
          strokeLinecap="round"
          opacity="0.25"
        />
        <line
          x1="640"
          y1="136"
          x2="672"
          y2="136"
          stroke="#f59e0b"
          strokeWidth="1"
          strokeDasharray="4 4"
          strokeLinecap="round"
          opacity="0.35"
        />

        {/* Lone accent dots */}
        <circle cx="8" cy="80" r="1.5" fill="#f59e0b" opacity="0.4" />
        <circle cx="692" cy="80" r="1.5" fill="#f59e0b" opacity="0.4" />
        <circle cx="350" cy="8" r="1.5" fill="#f59e0b" opacity="0.3" />
        <circle cx="350" cy="152" r="1.5" fill="#f59e0b" opacity="0.3" />
      </svg>
    </Box>
  );
}

const MoneyBackGuarantee = ({ backgroundColor = "white" }) => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        backgroundColor,
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 4, md: 6 },
        }}
      >
        <Box
          sx={{
            borderRadius: 4,
            p: { xs: 4, sm: 5 },
            backgroundColor: "#131a34",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            textAlign: "center",
            position: "relative",
          }}
        >
          <ScatteredDots />
          {/* Header Row */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              mb: 2,
            }}
          >
            <VerifiedIcon sx={{ color: "#12b2f1", fontSize: 32 }} />
            <Typography variant="h5" sx={{ fontWeight: 900, color: "white" }}>
              30-Day Money-Back Guarantee
            </Typography>
          </Box>

          {/* Body Text */}
          <Typography
            variant="body1"
            sx={{
              color: "rgba(255,255,255,0.85)",
              maxWidth: 600,
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Try Kloud Scan with confidence. If you're not completely satisfied
            within 30 days, we'll refund your purchase. No questions asked.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MoneyBackGuarantee;
